import { render, staticRenderFns } from "./Court.vue?vue&type=template&id=63edd9cf&scoped=true"
import script from "./Court.vue?vue&type=script&lang=js"
export * from "./Court.vue?vue&type=script&lang=js"
import style0 from "./Court.vue?vue&type=style&index=0&id=63edd9cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63edd9cf",
  null
  
)

export default component.exports